import { Link } from "react-router-dom";
import Logo from "../../../assets/img_logo.png";
import './footer_style.scss';
import ImgFormAvatar from './../../../assets/img_form_avatar.png';
import { useEffect, useState } from "react";
import axios from "axios";

export const Footer = ({
    globalOptions,
    footerMenu
}) => {
    const [isSucceed, setIsSucceed] = useState(false);
    const [fullName, setFullName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isFetching, setIsFetching] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        document.getElementById('phone_1').addEventListener('input', function (e) {
            var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            setPhone(!x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : ''));
        });
    }, []);

    const onSubmitForm = async (e) => {

        e.preventDefault();
        setIsSubmitting(true);

        try {
            await axios.post(
                '/wp-json/gf/v2/forms/1/submissions', // Replace {form_id} with your actual Gravity Form ID
                {
                    'input_1': fullName,
                    'input_3': email,
                    'input_4': phone,
                    'input_5': message,
                    'input_6': window.location.href,
                },
                {
                  headers: {
                    'Content-Type': 'application/json',
                  },
                }
            );

            setFullName('');
            setPhone('');
            setEmail('');
            setMessage('');
            setIsSucceed(true);
        } catch (err) {
            console.log(err);
        } finally {
            setIsSubmitting(false);
        }
        return false;
    }
    return <footer id="footer">
        <div className="container">
            <div className="footer-form-wrapper">
                <div className="form-wrapper">
                    <div className="footer-form-heading">
                        <span className="form-title">
                            Get a Free Consultation.
                        </span>
                        <img src={ImgFormAvatar} />
                        <span className="form-description">
                            Hi, this is Joe, founder of JTM Jr. & Associates.
                            We would love to connect and provide a free consultation
                        </span>
                        {
                            isSucceed && <span className='succeed'>Form submitted successfully!</span>
                        }
                    </div>
                    <form id="footer-form" onSubmit={onSubmitForm}>
                        <div className="form-fields">
                            <div className="field">
                                <input 
                                    type="text" 
                                    name="name" 
                                    id="name" 
                                    placeholder="Name" 
                                    required 
                                    value={fullName}
                                    onChange={(e) => {
                                        setFullName(e?.target?.value ?? "")
                                    }}
                                />
                            </div>
                            <div className="field">
                                <input 
                                    type="email" 
                                    name="email" 
                                    id="email" 
                                    placeholder="Email" 
                                    required
                                    value={email}
                                    onChange={(e) => {
                                        setEmail(e?.target?.value ?? "");
                                    }}
                                />
                            </div>
                            <div className="field">
                                <input
                                    type="phone" 
                                    name="phone_1" 
                                    id="phone_1" 
                                    placeholder="Phone" 
                                    value={phone}
                                    onChange={(e) => {
                                        setPhone(e?.target?.value ?? "")
                                    }}
                                    required 
                                />
                            </div>
                            <div className="field">
                                <textarea 
                                    name="message" 
                                    id='message' 
                                    placeholder="Tell us about your case"
                                    value={message}
                                    onChange={(e) => {
                                        setMessage(e?.target?.value ?? "")
                                    }}
                                />
                            </div>
                        </div>
                        <button type="submit" className={`button ${isSubmitting ? 'disabled' : ''}`}>
                            { isSubmitting ? 'Submitting...' : 'Make an appointment'}
                        </button>
                    </form>
                </div>
            </div>
            <div className="footer-inner-wrapper">
                <div className="footer-logo">
                    <Link to="/">
                        <img src={Logo} /> 
                    </Link>
                </div>

                <div className="footer-contact-details">
                    <ul>
                        <li>
                            <div className="contact-item">
                                <span className="icon">
                                    <svg width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10 13C10.6875 13 11.276 12.7552 11.7656 12.2656C12.2552 11.776 12.5 11.1875 12.5 10.5C12.5 9.8125 12.2552 9.22396 11.7656 8.73438C11.276 8.24479 10.6875 8 10 8C9.3125 8 8.72396 8.24479 8.23438 8.73438C7.74479 9.22396 7.5 9.8125 7.5 10.5C7.5 11.1875 7.74479 11.776 8.23438 12.2656C8.72396 12.7552 9.3125 13 10 13ZM10 22.1875C12.5417 19.8542 14.4271 17.7344 15.6563 15.8281C16.8854 13.9219 17.5 12.2292 17.5 10.75C17.5 8.47917 16.776 6.61979 15.3281 5.17188C13.8802 3.72396 12.1042 3 10 3C7.89583 3 6.11979 3.72396 4.67188 5.17188C3.22396 6.61979 2.5 8.47917 2.5 10.75C2.5 12.2292 3.11458 13.9219 4.34375 15.8281C5.57292 17.7344 7.45833 19.8542 10 22.1875ZM10 25.5C6.64583 22.6458 4.14062 19.9948 2.48438 17.5469C0.828125 15.099 0 12.8333 0 10.75C0 7.625 1.00521 5.13542 3.01563 3.28125C5.02604 1.42708 7.35417 0.5 10 0.5C12.6458 0.5 14.974 1.42708 16.9844 3.28125C18.9948 5.13542 20 7.625 20 10.75C20 12.8333 19.1719 15.099 17.5156 17.5469C15.8594 19.9948 13.3542 22.6458 10 25.5Z" fill="#CAAE7D"/>
                                    </svg>
                                </span>
                                <span className="label">
                                    { globalOptions?.contact_address ?? '20 Vesey Street, Suite 710, New York, NY 10007' }
                                </span>
                            </div>
                        </li>
                        <li>
                            <a href={`tel:${globalOptions?.contact_phone_number}`} className="contact-item">
                                <span className="icon">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20.75 12C20.75 9.5625 19.901 7.49479 18.2031 5.79688C16.5052 4.09896 14.4375 3.25 12 3.25V0.75C13.5625 0.75 15.026 1.04688 16.3906 1.64063C17.7552 2.23438 18.9427 3.03646 19.9531 4.04688C20.9635 5.05729 21.7656 6.24479 22.3594 7.60938C22.9531 8.97396 23.25 10.4375 23.25 12H20.75ZM15.75 12C15.75 10.9583 15.3854 10.0729 14.6562 9.34375C13.9271 8.61458 13.0417 8.25 12 8.25V5.75C13.7292 5.75 15.2031 6.35938 16.4219 7.57812C17.6406 8.79688 18.25 10.2708 18.25 12H15.75ZM21.9375 23.25C19.3333 23.25 16.7604 22.6823 14.2188 21.5469C11.6771 20.4115 9.36458 18.8021 7.28125 16.7188C5.19792 14.6354 3.58854 12.3229 2.45313 9.78125C1.31771 7.23958 0.75 4.66667 0.75 2.0625C0.75 1.6875 0.875 1.375 1.125 1.125C1.375 0.875 1.6875 0.75 2.0625 0.75H7.125C7.41667 0.75 7.67708 0.848958 7.90625 1.04688C8.13542 1.24479 8.27083 1.47917 8.3125 1.75L9.125 6.125C9.16667 6.45833 9.15625 6.73958 9.09375 6.96875C9.03125 7.19792 8.91667 7.39583 8.75 7.5625L5.71875 10.625C6.13542 11.3958 6.63021 12.1406 7.20312 12.8594C7.77604 13.5781 8.40625 14.2708 9.09375 14.9375C9.73958 15.5833 10.4167 16.1823 11.125 16.7344C11.8333 17.2865 12.5833 17.7917 13.375 18.25L16.3125 15.3125C16.5 15.125 16.7448 14.9844 17.0469 14.8906C17.349 14.7969 17.6458 14.7708 17.9375 14.8125L22.25 15.6875C22.5417 15.7708 22.7812 15.9219 22.9688 16.1406C23.1562 16.3594 23.25 16.6042 23.25 16.875V21.9375C23.25 22.3125 23.125 22.625 22.875 22.875C22.625 23.125 22.3125 23.25 21.9375 23.25ZM4.53125 8.25L6.59375 6.1875L6.0625 3.25H3.28125C3.38542 4.10417 3.53125 4.94792 3.71875 5.78125C3.90625 6.61458 4.17708 7.4375 4.53125 8.25ZM15.7188 19.4375C16.5313 19.7917 17.3594 20.0729 18.2031 20.2812C19.0469 20.4896 19.8958 20.625 20.75 20.6875V17.9375L17.8125 17.3438L15.7188 19.4375Z" fill="#CAAE7D"/>
                                    </svg>
                                </span>
                                <span className="label">
                                {globalOptions?.contact_phone_number ?? '(332) 669-7853'}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a href={`mailto:${globalOptions?.contact_email_address}`} className="contact-item">
                                <span className="icon">
                                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13 0.25L24.3125 7C24.6875 7.22917 24.9792 7.54167 25.1875 7.9375C25.3958 8.33333 25.5 8.75 25.5 9.1875V22.75C25.5 23.4375 25.2552 24.026 24.7656 24.5156C24.276 25.0052 23.6875 25.25 23 25.25H3C2.3125 25.25 1.72396 25.0052 1.23438 24.5156C0.744792 24.026 0.5 23.4375 0.5 22.75V9.1875C0.5 8.75 0.604167 8.33333 0.8125 7.9375C1.02083 7.54167 1.3125 7.22917 1.6875 7L13 0.25ZM13 14.8125L22.75 9L13 3.1875L3.25 9L13 14.8125ZM13 17.75L3 11.75V22.75H23V11.75L13 17.75Z" fill="#CAAE7D"/>
                                    </svg>
                                </span>
                                <span className="label">
                                    {globalOptions?.contact_email_address ?? 'lawyerjtmjr@aol.com'}
                                </span>
                            </a>
                        </li>
                        <li>
                            <a href={globalOptions?.social_linkedin?.link} className="contact-item">
                                <span className="icon">
                                    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.92446 20H0.363393V6.64702H4.92446V20ZM2.64147 4.82555C1.18299 4.82555 0 3.72732 0 2.40139C1.04392e-08 1.7645 0.278297 1.1537 0.77367 0.703352C1.26904 0.253003 1.94091 0 2.64147 0C3.34204 0 4.0139 0.253003 4.50928 0.703352C5.00465 1.1537 5.28295 1.7645 5.28295 2.40139C5.28295 3.72732 4.09946 4.82555 2.64147 4.82555ZM21.9951 20H17.4438V13.4999C17.4438 11.9507 17.4095 9.96406 15.0725 9.96406C12.7011 9.96406 12.3377 11.6471 12.3377 13.3882V20H7.78152V6.64702H12.156V8.46849H12.2198C12.8287 7.41936 14.3162 6.31219 16.5354 6.31219C21.1514 6.31219 22 9.07565 22 12.665V20H21.9951Z" fill="#CAAE7D"/>
                                    </svg>
                                </span>
                                <span className="label">
                                    {globalOptions?.social_linkedin?.label ?? 'Joseph T. Mullen'}
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="footer-legal-wrapper">
                <p>{ globalOptions?.footer_legal_content ?? "Ⓒ 2024 - All Rights Are Reserved - Joseph T. Mullen, Jr. & Associates" }</p>
            </div>
        </div>
    </footer>
}